import { render, staticRenderFns } from "./IconLinkList.vue?vue&type=template&id=7b2c38e8&scoped=true&"
import script from "./IconLinkList.vue?vue&type=script&lang=js&"
export * from "./IconLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c38e8",
  null
  
)

export default component.exports